// extracted by mini-css-extract-plugin
export var cartContainer = "_n2-4";
export var gray = "_n2-1";
export var itemContainer = "_n2-2";
export var itemDetails = "_n2-3";
export var strong = "_n2-0";